import { render } from "./PcFooter.vue?vue&type=template&id=1e47b870"
const script = {}

import "./PcFooter.vue?vue&type=style&index=0&id=1e47b870&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9acfb15ce118456a03f39fb117bb0076/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__